import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Typography,
} from '@material-ui/core'
import ReportProblemOutlinedIcon from '@material-ui/icons/ReportProblemOutlined'

import Button from '@/components/button'

import { useStyles } from './style'

interface CancelModalProps {
  open: boolean
  onClose?: () => void
  onSubmit?: () => void
  diangosisName?: string
  isLoading?: boolean
}

export function CancelModal({
  open,
  onClose,
  onSubmit,
  diangosisName,
  isLoading,
}: CancelModalProps) {
  const classes = useStyles()

  return (
    <Dialog
      open={open}
      onClose={onClose}
      classes={{
        paper: classes.main,
      }}
    >
      <DialogTitle disableTypography classes={{ root: classes.dialogTitle }}>
        <ReportProblemOutlinedIcon />
        <Typography variant={'h2'}>Cancelar diagnóstico</Typography>
      </DialogTitle>
      <DialogContent
        classes={{
          root: classes.dialogContent,
        }}
      >
        <ul>
          <Typography component={'li'}>
            Tem certeza que gostaria de cancelar o diagnóstico{' '}
            <strong>{diangosisName}</strong>? <br />
            Essa ação não poderá ser desfeita.
          </Typography>
        </ul>
      </DialogContent>
      <DialogActions
        classes={{
          root: classes.dialogActions,
        }}
      >
        <Button onClick={onClose} outlined disabled={isLoading}>
          Voltar
        </Button>

        <Button onClick={onSubmit} error disabled={isLoading}>
          Cancelar diagnóstico
        </Button>
      </DialogActions>
    </Dialog>
  )
}
